import React, { Component } from 'react';
import api from '../utils/api';
import { withRouter } from 'react-router-dom';
import AddressForm from './MemberAddressForm';
import useAuth from '../context/useAuth';



class EditMember extends Component {
    constructor(props) {
        super(props);
        console.log(props);

        const { member } = props.location.state || {};
        const { searchCriteria, currentPage } = props.location.state || {};

        this.state = {
            memberId: member?.memberId || '',
            first1: member?.first1 || '',
            middle1: member?.middle1 || '',
            last1: member?.last1 || '',
            first2: member?.first2 || '',
            middle2: member?.middle2 || '',
            last2: member?.last2 || '',
            address: member?.address || '',
            address2: member?.address2 || '',
            city: member?.city || '',
            state: member?.state || '',
            zip: member?.zip || '',
            country: member?.country || '',
            phone1: member?.phone1 || '',
            phone2: member?.phone2 || '',
            email: member?.email || '',
            memberType: member?.memberType || '', // will default to DEVOTEE if not set
            isNameConfidential: member?.isNameConfidential || false,
            searchCriteria,
            currentPage,
            error: null,
            success: null,
            role:props.role,
            referenceMemberTypes: [],
        };
    }

    componentDidMount() {
        this.fetchReferenceMemberTypes();
    }

    fetchReferenceMemberTypes = async () => {
        try {
            // Fetch reference type id for 'Member Type'
            const typesRes = await api.get('/api/reference_types');
            const memberTypeObj = typesRes.data.find(t => t.type_name === 'Member Type');
            if (!memberTypeObj) {
                this.setState({ referenceMemberTypes: [] });
                return;
            }
            // Fetch values for this type
            const valuesRes = await api.get('/api/reference_values', { params: { type_id: memberTypeObj.id } });
            this.setState({ referenceMemberTypes: valuesRes.data });
        } catch (err) {
            this.setState({ referenceMemberTypes: [] });
        }
    };

    handleChange = (event) => {
        const { name, value } = event.target;
        // Ensure no logic here is removing spaces
        this.setState({
            [name]: value
        });
    };

    onChangeCheckbox = (e) => {
        this.setState({ isNameConfidential: e.target.checked });
    };

    validateForm = () => {
        const {
            first1, last1, /* memberType, */ email
        } = this.state;

        if (!first1 || !last1) return 'First name and Last name are required.';
        // Remove memberType required check

        // Improved email validation: only check if provided, must match pattern and not contain consecutive dots
        if (
            email &&
            (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || email.includes('..'))
        ) {
            return 'Please enter a valid email address.';
        }

        return '';
    }



    handleSubmit = (e) => {
        e.preventDefault();

        const error = this.validateForm();
        if (error) {
            this.setState({ error });
            return;
        }
        // Default memberType to DEVOTEE if not set
        const data = {
            ...this.state,
            memberType: this.state.memberType || 'DEVOTEE'
        };
        delete data.error;
        delete data.success;
        const { searchCriteria, currentPage } = this.state;

        api.put(`/api/members/${this.state.memberId}`, data)
            .then((res) => {
                this.setState({ success: 'Member updated successfully!' });
                setTimeout(() => {
                    this.props.history.push({
                        pathname: `/memberDetails/${this.state.memberId}`,
                        state: { searchCriteria, currentPage }
                    });
                }, 2000); // Redirect after 2 seconds
            })
            .catch((error) => {
                this.setState({ error: 'Failed to update member. Please try again later.' });
            });
    };

    render() {
        return (
            <div className="p-0">
                <div className="p-4 border border-secondary">
                    {/* Error and Success Messages */}
                    {this.state.error && (
                        <div className="alert alert-danger mt-3">
                            {this.state.error}
                        </div>
                    )}
                    {this.state.success && (
                        <div className="alert alert-success mt-3">
                            {this.state.success}
                        </div>
                    )}
                    <div style={{ backgroundColor: "lightblue" }}>
                        <div className="text-center">Edit Member</div>
                        <form onSubmit={this.handleSubmit}>
                            {/* Personal Information */}
                            <div className="form-row p-3">
                                <div className="col">
                                    <div className="md-form">
                                        <label htmlFor="firstName1">First name <span className="text-danger">*</span></label>
                                        <input
                                            onChange={this.handleChange}
                                            type="text"
                                            id="firstName1"
                                            placeholder="First Name"
                                            name="first1"
                                            className="form-control"
                                            value={this.state.first1}
                                        />
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="md-form">
                                        <label htmlFor="middleName1">Middle name</label>
                                        <input
                                            onChange={this.handleChange}
                                            type="text"
                                            id="middleName1"
                                            placeholder="Middle Name"
                                            name="middle1"
                                            className="form-control"
                                            value={this.state.middle1}
                                        />
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="md-form">
                                        <label htmlFor="lastName1">Last name <span className="text-danger">*</span></label>
                                        <input
                                            onChange={this.handleChange}
                                            type="text"
                                            id="lastName1"
                                            placeholder="Last Name"
                                            name="last1"
                                            className="form-control"
                                            value={this.state.last1}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Spouse Information */}
                            <div style={{ backgroundColor: "mistyrose" }}>
                                <div className="text-center">Spouse</div>
                                <div className="form-row p-3">
                                    <div className="col">
                                        <div className="md-form">
                                            <label htmlFor="firstName2">First name</label>
                                            <input
                                                onChange={this.handleChange}
                                                type="text"
                                                id="firstName2"
                                                placeholder="First Name"
                                                name="first2"
                                                className="form-control"
                                                value={this.state.first2}
                                            />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="md-form">
                                            <label htmlFor="middleName2">Middle name</label>
                                            <input
                                                onChange={this.handleChange}
                                                type="text"
                                                id="middleName2"
                                                placeholder="Middle Name"
                                                name="middle2"
                                                className="form-control"
                                                value={this.state.middle2}
                                            />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="md-form">
                                            <label htmlFor="lastName2">Last name</label>
                                            <input
                                                onChange={this.handleChange}
                                                type="text"
                                                id="lastName2"
                                                placeholder="Last Name"
                                                name="last2"
                                                className="form-control"
                                                value={this.state.last2}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Address and Other Details */}
                            <AddressForm
                                address={this.state.address}
                                address2={this.state.address2}
                                city={this.state.city}
                                state={this.state.state}
                                zip={this.state.zip}
                                country={this.state.country}
                                phone1={this.state.phone1}
                                phone2={this.state.phone2}
                                email={this.state.email}
                                memberType={this.state.memberType || 'DEVOTEE'}
                                referenceMemberTypes={this.state.referenceMemberTypes}
                                isNameConfidential= {this.state.isNameConfidential}
                                onChangeInput={this.handleChange}
                                onChangeCheckbox={this.onChangeCheckbox}
                                role={this.state.role}
                            />
                            {/* Submit and Cancel Buttons */}
                            <div className="text-center mt-3">
                                <button className="btn btn-primary m-1" type="submit">Save Changes</button>
                                <button
                                    className="btn btn-secondary m-1"
                                    onClick={() => this.props.history.goBack()}
                                >
                                    Cancel
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

// Higher-Order Component (HOC) to pass the role from useAuth
const EditMemberWithRole = (props) => {
    const { role } = useAuth(); // Get role from auth context
    return <EditMember {...props} role={role} />;
};

export default withRouter(EditMemberWithRole);

